// Punto de entrada del módulo de tablero de delegados.
// Para migrar: copiar la carpeta src/delegate y registrar rutas + link como en App.js / links.js.

import { lazy } from "react";

export const DelegateGames = lazy(() => import("./pages/DelegateGames"));
export const DelegateGameBoard = lazy(() => import("./pages/DelegateGameBoard"));

export { DELEGATE_PATH, DELEGATE_ROLES, delegateLinks } from "./config";
